import gql from 'graphql-tag'

const query = gql`
query {
  cashAssist {
    clientTree {
      regions {
        id
        name
        shops {
        	id
        }
      }
    }
    listShops {
      items {
      	id
	      name
	      regionId
	      cashRegisters {
	        id
			    name
			    shopId
			    isAvailableInWebApp
	      }
      }
    }
    getAppConfig {
    	language
			mainCurrency
		}
		getDashboardDSGeo {
			id
		  coordinates
		  google_map_url
		}
  }
}
`
export default query
